import ifNotEmpty from './ifNotEmpty';

export const requiredPhone = phone => {
  if (
    !/^((\+447|07|00447|08)(\s?\d{1}){9})$|((01|02|03)(\s?\d{1}){5,20})$/.test(
      phone,
    )
  ) {
    // eslint-disable-next-line quotes
    return "Please ensure you enter a valid UK landline or mobile number beginning with '0' or '+44'";
  }
};

export const optionalPhone = ifNotEmpty(requiredPhone);
